<script setup lang="ts"></script>

<template lang="pug">
h2.text-h2
  slot
</template>
